import { Navigate, Route, Routes } from "react-router-dom";

import { ServiceGuard } from "../components/ServiceGuard";
import { AttendancePage } from "../pages/AttendancePage";
import ForceSignOut from "../pages/Auth/ForceSignOut";
import { BookingsPage } from "../pages/BookingsPage";
import { DashboardPage } from "../pages/DashboardPage";
import { DocumentsPage } from "../pages/DocumentsPage";
import { EducatorsPage } from "../pages/EducatorsPage";
import { EscalationPathPage } from "../pages/EscalationPathPage";
import { FeeInformationFlyerPage } from "../pages/FeeInformationFlyerPage";
import KeyDatesPage from "../pages/KeyDatesPage";
import { OperationalInformationPage } from "../pages/OperationalInformationPage";
import RocketeersDays from "../pages/RocketeersDays";
import RocketeersPage from "../pages/RocketeersPage";
import { SchoolContactsPage } from "../pages/SchoolContactsPage";
import { ServiceSelector } from "../pages/ServiceSelector";
import { VisitSummaryPage } from "../pages/VisitSummaryPage";
import { WebsiteContentPage } from "../pages/WebsiteContentPage";

function AuthenticatedRoutes() {
  return (
    <Routes>
      <Route path="/logout" element={<ForceSignOut />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/services" element={<ServiceSelector />} />
      <Route path="/new-dashboard" element={<DashboardPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/attendance" element={<AttendancePage />} />
      <Route
        path="/educators"
        element={
          <ServiceGuard>
            <EducatorsPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/school-contacts"
        element={
          <ServiceGuard>
            <SchoolContactsPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/escalation-path"
        element={
          <ServiceGuard>
            <EscalationPathPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/bookings"
        element={
          <ServiceGuard>
            <BookingsPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/holiday-club"
        element={
          <ServiceGuard>
            <RocketeersDays />
          </ServiceGuard>
        }
      />
      <Route
        path="/rocketeers"
        element={
          <ServiceGuard>
            <RocketeersPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/operational-information"
        element={
          <ServiceGuard>
            <OperationalInformationPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/visit-summary"
        element={
          <ServiceGuard>
            <VisitSummaryPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/documents"
        element={
          <ServiceGuard>
            <DocumentsPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/website-content"
        element={
          <ServiceGuard>
            <WebsiteContentPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/key-dates"
        element={
          <ServiceGuard>
            <KeyDatesPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/fee-information"
        element={
          <ServiceGuard>
            <FeeInformationFlyerPage />
          </ServiceGuard>
        }
      />
      <Route
        path="/fee-information-fbo"
        element={
          <ServiceGuard>
            <FeeInformationFlyerPage isFbo={true} />
          </ServiceGuard>
        }
      />
      <Route
        path="/surveys"
        element={
          <ServiceGuard>
            <div>Surveys Page - Coming Soon</div>
          </ServiceGuard>
        }
      />
      <Route path="/*" element={<Navigate to="/services" replace />} />
    </Routes>
  );
}

export default AuthenticatedRoutes;
